import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { sendHook } from '../../store/app/apis';
import Toast from 'light-toast';
import Switch from '@mui/material/Switch';

function SendHook({ token, ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl1);
  const [checked, setChecked] = React.useState(false);

  const [state, setState] = useState({
    hookid: props.id,
    subject: '',
    text: '',
    to: [''],
    files: [],
  });

  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };
  const handleUploadChange = (e) => {
    setState((prev) => ({
      ...prev,
      files: e.target.files,
    }));
  };
  const handleHookIdChange = (e) => {
    setState((prev) => ({
      ...prev,
      hookid: e.target.value,
    }));
  };
  const handleSubjectChange = (e) => {
    setState((prev) => ({
      ...prev,
      subject: e.target.value,
    }));
  };
  const handleTextChange = (e) => {
    setState((prev) => ({
      ...prev,
      text: e.target.value,
    }));
  };
  const handleToChange = (e) => {
    setState((prev) => ({
      ...prev,
      to: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state?.hookid === '') {
      Toast.fail('Please enter all details!');
    } else {
      sendHook(state, token, () => {
        setState((prev) => ({
          ...prev,
          subject: '',
          text: '',
          to: [''],
          files: [],
        }));
      });
      cancelPop();
    }
  };
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    setAnchorEl(props.anchorEl1);
  }, [props.anchorEl1]);

  return (
    <>
      <Dialog id="create-popover" open={anchorEl !== null} onClose={cancelPop}>
        <Box
          sx={{
            padding: '20px',
          }}
        >
          <div className="formTitle">
            <h3>Send Hook Form </h3>
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer' }} />
          </div>
          <form className="forminfo">
            <div className="telegramInfo">
              <div className="forminput" style={{ paddingTop: 15 }}>
                <label>HookId</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleHookIdChange}
                  placeholder="HookId"
                  value={state?.hookid}
                  variant="outlined"
                />
              </div>
              <div className="forminput" style={{ paddingTop: 15 }}>
                <label>Text</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleTextChange}
                  placeholder="Text"
                  value={state?.text}
                  variant="outlined"
                />
              </div>
              <div className="forminput" style={{ paddingTop: 15 }}>
                <label>Subject</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleSubjectChange}
                  placeholder="Subject"
                  value={state?.subject}
                  variant="outlined"
                />
              </div>
              <div className="forminput" style={{ paddingTop: 15 }}>
                <label>To</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleToChange}
                  placeholder="To"
                  value={state?.to}
                  variant="outlined"
                />
              </div>
            </div>
            <div>
              <span style={{ float: 'right' }}>
                <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
              </span>
              <span>Upload File</span>
            </div>
            {checked && (
              <div className="forminput" style={{ paddingTop: 15 }}>
                <button component="label">
                  Upload
                  <input
                    hidden
                    multiple
                    type="file"
                    onChange={(event) => {
                      handleUploadChange(event);
                    }}
                  />
                </button>
              </div>
            )}
            <button onClick={handleSubmit} style={{ float: 'right', marginTop: '5px' }}>
              Send
            </button>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.app.user.token,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SendHook);
